import { useCallback } from "react";
import { RootState } from "../store";
import { useAppDispatch, useAppSelector } from "./hooks";
import * as ResolucaoActions from "../store/Resolucao.reducer";

export default function useResolucaoQuestoes() {
  const dispatch = useAppDispatch();

  const resolucoes = useAppSelector((state: RootState) => state.resolucao.list);
  const filterQuery = useAppSelector((state: RootState) => state.resolucao.filterQuery);
  const paginatedResult = useAppSelector((state: RootState) => state.resolucao.paginatedResult);

  const resolucaoAtual = useAppSelector(
    (state: RootState) => state.resolucao.questaoAtual
  );
  const resolucaoAnterior = useAppSelector(
    (state: RootState) => state.resolucao.questaoAnterior
  );
  const resolucaoProxima = useAppSelector(
    (state: RootState) => state.resolucao.questaoProxima
  );

  const fetching = useAppSelector(
    (state: RootState) => state.resolucao.fetching
  );

  /*  const buscarQuestoesAleatorias = useCallback(async (banca: Banca.Banca, dificuldade: 'DIFICIL' | 'FACIL' | 'MEDIO', materia: Materia.Materia) => {
    setLoadingBusca(true);
    try {
      const questoes = await QuestaoService.getQuestoesAleatorias(banca, dificuldade, materia);

      let novaLista: Array<Resolucao.ResolucaoQuestao> = questoes.map((item) => ({
        questao: item,
      }));

      setResolucoes(novaLista);
    } finally {
      setLoadingBusca(false);
    }
  }, []); */

  const buscarPaginada = useCallback(
    () => {
      dispatch(ResolucaoActions.buscaPaginada());
    },
    [dispatch]
  );

  const proximaPaginacao = useCallback(
    () => {
      dispatch(ResolucaoActions.proximaPaginacao());
    },
    [dispatch]
  );

  const paginacaoAnterior = useCallback(
    () => {
      dispatch(ResolucaoActions.paginacaoAnterior());
    },
    [dispatch]
  );

  // Returns the dispatch promise so callers can await the committed filter
  // before firing buscarPaginada, which reads filterQuery back off the store.
  const setFilter = useCallback(
    (object: any) => {
      return dispatch(ResolucaoActions.setFilter(object));
    },
    [dispatch]
  );

  const buscarQuestoesAleatorias = useCallback(
    (object: any) => {
      dispatch(ResolucaoActions.buscarQuestoesAleatorias(object));
    },
    [dispatch]
  );

  const marcarAcaoNasResolucoes = useCallback(
    (object: any) => {
      dispatch(ResolucaoActions.marcarAcaoNasResolucoes(object));
    },
    [dispatch]
  );

  const exibirResposta = useCallback(
    (object: any) => {
      dispatch(ResolucaoActions.exibirResposta(object));
    },
    [dispatch]
  );

  const confirmarResposta = useCallback(
    (object: any) => {
      dispatch(ResolucaoActions.confirmarResposta(object));
    },
    [dispatch]
  );

  const marcarResolucaoAtual = useCallback(
    (object: any) => {
      dispatch(ResolucaoActions.marcarResolucaoAtual(object));
    },
    [dispatch]
  );

  return {
    buscarPaginada,
    proximaPaginacao,
    paginacaoAnterior,
    buscarQuestoesAleatorias,
    marcarAcaoNasResolucoes,
    exibirResposta,
    confirmarResposta,
    marcarResolucaoAtual,
    setFilter,   
    resolucoes,
    filterQuery,
    paginatedResult,
    resolucaoAtual,
    resolucaoAnterior,
    resolucaoProxima,
    fetching,
  };
}
